import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useSectionActionPlan } from './context';
import { Text } from '@/components/Typography';
import * as S from './styles';

export function Header() {
	const { name, description, score } = useSectionActionPlan();
	return (
		<Col span={24}>
			<Row justify="space-between" align="middle">
				<S.Title span={12}>
					<Text className="label">
						{I18n.get('Section')} {name}:
					</Text>
					<Text className="description">{description}</Text>
				</S.Title>
				<S.Score>
					<span>{score}</span>
				</S.Score>
			</Row>
		</Col>
	);
}
